import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  slides: [],
  currentSlide: null,
};

export const uniSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setSlides: (state, action) => {
      const payload = action.payload || [];
      state.slides = Array.isArray(payload) ? payload : [];
      if (state.slides.length > 0 && !state.currentSlide) {
        state.currentSlide = state.slides[0];
      }
      return state;
    },
    setCurrentSlide: (state, action) => {
      state.currentSlide = action.payload ?? null;
      return state;
    },
    /** Update the current slide's content in place (e.g. after save) so we don't replace with stale refetch. */
    updateCurrentSlideContent: (state, action) => {
      const data = action.payload;
      if (!state.currentSlide || data == null) return state;
      const content = { ...(state.currentSlide.content || {}), data };
      state.currentSlide = { ...state.currentSlide, content };
      const idx = state.slides.findIndex((s) => s.id === state.currentSlide.id);
      if (idx >= 0) state.slides[idx] = { ...state.slides[idx], content };
      return state;
    },
    updateSlideContentById: (state, action) => {
      const { slideId, data } = action.payload || {};
      if (!slideId || data == null) return state;
      const idx = state.slides.findIndex((s) => s.id === slideId);
      if (idx >= 0) {
        const content = { ...(state.slides[idx].content || {}), data };
        state.slides[idx] = { ...state.slides[idx], content };
        if (state.currentSlide?.id === slideId) {
          state.currentSlide = { ...state.currentSlide, content };
        }
      }
      return state;
    },
  },
});

const uniReducer = uniSlice.reducer;

export const { setSlides, setCurrentSlide, updateCurrentSlideContent, updateSlideContentById } =
  uniSlice.actions;

export default uniReducer;
